/**
 * Row normalisers for the /my/backups surfaces (rb-0815 Gate 3).
 *
 * The backup-api keys rows by `schedule_id` / `job_id`, schedules carry no
 * `name`, and jobs carry `start_time` / `end_time` — while the Vuex store and
 * MyBackups.vue read `id`, `name`, `started_at`, `finished_at`. Before this
 * normalisation, schedule rows rendered "(unnamed)" and Enable / Run-now
 * POSTed `/api/backup/schedules/undefined/{enable,run-now}` → 404, and the
 * History tab's Started / Duration columns rendered "–".
 *
 * Kept dependency-free (no aliases, no store) so it runs under
 * `node --test tests/unit/` — same pattern as utils/certs-shape.js.
 */

export function normalizeScheduleRow(row) {
  if (!row || typeof row !== 'object' || Array.isArray(row)) return row
  const id = row.schedule_id ?? row.id
  const name =
    row.name ||
    [row.type, row.cron].filter(Boolean).join(' · ') ||
    '(schedule)'
  return { ...row, id, name }
}

export function normalizeJobRow(row) {
  if (!row || typeof row !== 'object' || Array.isArray(row)) return row
  return {
    ...row,
    id: row.job_id ?? row.id,
    started_at: row.started_at ?? row.start_time ?? null,
    finished_at: row.finished_at ?? row.end_time ?? null
  }
}
